(() => {
  "use strict";

  const ASSET_ORIGIN = "https://the-c-curl-concept.the-c-curl-5016.chatgpt.site";
  const asset = (path) => `${ASSET_ORIGIN}${path}`;
  const select = (selector, root = document) => root.querySelector(selector);
  const selectAll = (selector, root = document) => [...root.querySelectorAll(selector)];

  const homepageReviews = [
    {
      quote: "I’m very happy with using the C Curl. I’m 64 with short lashes and the C Curl has really lifted my lashes to where I can see them!",
      name: "Sophia R.",
      date: "July 2026",
    },
    {
      quote: "Recently, I’ve lost a spot of eyelashes on both eyes. The C Curl seems to be just what I need right now. It is curling my lashes without causing more stress or loss. YAY!",
      name: "Marjorie C.",
      date: "July 2026",
    },
    {
      quote: "I have super straight lashes that never hold a curl…until this. This curler actually lifts them and keeps them curled all day.",
      name: "Jess B.",
      date: "April 2026",
    },
    {
      quote: "It's easy to use with less damage to lashes. My lashes look exponentially longer and thicker since using this curler.",
      name: "Rosemary V.",
      date: "May 2026",
    },
    {
      quote: "This actually works. I was so skeptical at first cause I have straight down asian lashes. But i threw away my old ones and only reaching out to this!",
      name: "Julie B.",
      date: "February 2026",
    },
  ];

  const bagCatalog = {
    comb: { name: "The Curl Comb", price: 11, image: "/products/pale-lavender/curl-comb-square.png", eyebrow: "PREP" },
    serum: { name: "Long Lash Growth Serum", price: 54, image: "/products/pale-lavender/ritual-serum-lavender.png", eyebrow: "CARE" },
    gel: { name: "Brett Brow Control Gel", price: 20, image: "/products/pale-lavender/brett-brow-control-gel.png", eyebrow: "GROOM + HOLD" },
    pads: { name: "Replacement Pads", price: 10, image: "/products/pale-lavender/replacement-pads.png", eyebrow: "MAINTAIN" },
    pencil: { name: "Duo Shade Brett Brow Pencil", price: 20, image: "/products/pale-lavender/duo-shade-brett-brow-pencil.png", eyebrow: "SHAPE + SHADE" },
  };

  const ritualOptions = [
    { key: "prep", name: "The Curl Comb", price: 11 },
    { key: "lift", name: "The C Curl", price: 24 },
    { key: "lasting", name: "Lasting Curl Mascara", price: 24 },
    { key: "colossal", name: "Colossal Curl Mascara", price: 24 },
  ];

  const state = {
    activeReview: 0,
    reviewPaused: false,
    reviewTimer: 0,
    curlerQty: 0,
    mascaraAdded: false,
    bagItems: {},
    ritualAdded: null,
    ritualSelections: { prep: true, lift: true, lasting: true, colossal: false },
  };

  let activeConsultation = null;
  let activeConsultationTrigger = null;
  const consultationStates = new WeakMap();

  const escapeHtml = (value) => String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");

  const arrow = '<span class="brand-arrow" aria-hidden="true">↗︎</span>';

  function setupHeader() {
    const header = select(".site-header");
    const menuButton = select(".site-menu-toggle");
    const navigation = select("#site-navigation");
    if (!header || !menuButton || !navigation) return;

    let menuOpen = false;
    let lastScrollY = window.scrollY;

    const setMenuOpen = (open) => {
      menuOpen = open;
      navigation.classList.toggle("is-open", open);
      menuButton.textContent = open ? "CLOSE" : "MENU";
      menuButton.setAttribute("aria-expanded", String(open));
      if (open) header.classList.remove("is-scroll-hidden");
    };

    menuButton.addEventListener("click", () => setMenuOpen(!menuOpen));
    selectAll("a", navigation).forEach((link) => link.addEventListener("click", () => setMenuOpen(false)));

    const handleScroll = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      if (window.innerWidth > 800 || menuOpen || currentScrollY < 96) {
        header.classList.remove("is-scroll-hidden");
        lastScrollY = currentScrollY;
        return;
      }

      const movement = currentScrollY - lastScrollY;
      if (Math.abs(movement) < 8) return;
      header.classList.toggle("is-scroll-hidden", movement > 0);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
  }

  function setupReviews() {
    const stage = select(".review-stage");
    const featured = select(".review-quote-featured", stage || document);
    if (!stage || !featured) return;

    const reviewDuration = 6200;
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );

    let remainingTime = reviewDuration;
    let timerStartedAt = 0;
    let timerRunning = false;

    const renderReview = () => {
      const review = homepageReviews[state.activeReview];

      featured.innerHTML = `
        <blockquote>
          <span class="quote-mark" aria-hidden="true">“</span>
          <span class="review-quote-text">
            ${escapeHtml(review.quote)}
          </span>
        </blockquote>

        <p class="stars" aria-label="Five-star verified review">
          ★★★★★
          <span>· ${escapeHtml(review.name.toUpperCase())}</span>
          <span class="verified-buyer">VERIFIED BUYER</span>
          <span>· ${escapeHtml(review.date.toUpperCase())}</span>
        </p>
      `;

      featured.style.animation = "none";
      void featured.offsetWidth;
      featured.style.animation = "";
    };

    const stopTimer = () => {
      if (!timerRunning) return;

      window.clearTimeout(state.reviewTimer);

      remainingTime = Math.max(
        0,
        remainingTime - (Date.now() - timerStartedAt)
      );

      timerRunning = false;
    };

    const scheduleReview = () => {
      window.clearTimeout(state.reviewTimer);
      timerRunning = false;

      const paused =
        state.reviewPaused || reducedMotion.matches;

      stage.classList.toggle("is-paused", paused);

      if (paused) return;

      timerStartedAt = Date.now();
      timerRunning = true;

      state.reviewTimer = window.setTimeout(() => {
        timerRunning = false;
        remainingTime = reviewDuration;

        state.activeReview =
          (state.activeReview + 1) % homepageReviews.length;

        renderReview();
        scheduleReview();
      }, Math.max(remainingTime, 20));
    };

    const pause = (paused) => {
      if (paused === state.reviewPaused) return;

      if (paused) {
        stopTimer();
      }

      state.reviewPaused = paused;
      stage.classList.toggle(
        "is-paused",
        paused || reducedMotion.matches
      );

      if (!paused) {
        scheduleReview();
      }
    };

    stage.addEventListener("pointerenter", (event) => {
      if (event.pointerType === "mouse") {
        pause(true);
      }
    });

    stage.addEventListener("pointerleave", (event) => {
      if (event.pointerType === "mouse") {
        pause(false);
      }
    });

    stage.addEventListener("pointerup", (event) => {
      if (event.pointerType !== "mouse") {
        pause(!state.reviewPaused);
      }
    });

    stage.addEventListener("focusin", () => {
      pause(true);
    });

    stage.addEventListener("focusout", () => {
      pause(false);
    });

    reducedMotion.addEventListener("change", () => {
      if (reducedMotion.matches) {
        stopTimer();
        stage.classList.add("is-paused");
      } else if (!state.reviewPaused) {
        scheduleReview();
      }
    });

    scheduleReview();
  }

  function setupBeforeAfterCarousel() {
    const rail = select(".before-after-rail");
    const dots = selectAll(".before-after-dots button");
    if (!rail || !dots.length) return;

    let ticking = false;
    const updateActiveDot = () => {
      const cards = [...rail.children];
      let activeIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - rail.offsetLeft - rail.scrollLeft);
        if (distance < closestDistance) {
          activeIndex = index;
          closestDistance = distance;
        }
      });
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle("is-active", active);
        if (active) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
      ticking = false;
    };

    rail.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateActiveDot);
    }, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const card = rail.children[index];
        if (card) rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: "smooth" });
      });
    });
  }

  function setupVideoRail() {
    const rail = select(".video-proof-rail");
    const cards = selectAll(".video-proof-card", rail || document);
    if (!rail || !cards.length) return;

    let activeFrame = null;
    const originals = new Map();

    const restoreFrame = (frame) => {
      if (!frame || !originals.has(frame)) return;
      frame.innerHTML = originals.get(frame);
      bindPlayButton(frame);
      if (activeFrame === frame) activeFrame = null;
    };

    const bindPlayButton = (frame) => {
      const button = select("button", frame);
      if (!button) return;

      button.addEventListener("click", () => {
        const videoUrl = button.dataset.videoUrl;
        const posterUrl = button.dataset.videoPoster;
        const isContained = button.dataset.videoContained === "true";
        if (!videoUrl) return;

        if (activeFrame && activeFrame !== frame) restoreFrame(activeFrame);

        const video = document.createElement("video");
        if (isContained) video.className = "is-contained";
        video.src = videoUrl;
        if (posterUrl) video.poster = posterUrl;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = "metadata";
        video.addEventListener("ended", () => restoreFrame(frame), { once: true });
        frame.replaceChildren(video);
        activeFrame = frame;
        video.play().catch(() => {});
      });
    };

    cards.forEach((card) => {
      const frame = select(".video-proof-frame", card);
      if (!frame) return;
      originals.set(frame, frame.innerHTML);
      bindPlayButton(frame);
    });

    const browseButtons = selectAll(".video-proof-browse button");
    browseButtons[0]?.addEventListener("click", () => rail.scrollBy({ left: -340, behavior: "smooth" }));
    browseButtons[1]?.addEventListener("click", () => rail.scrollBy({ left: 340, behavior: "smooth" }));
  }


  const getRitualSelection = () => ritualOptions.filter((option) => state.ritualSelections[option.key]);
  const getRitualTotal = () => getRitualSelection().reduce((total, option) => total + option.price, 0);
  const getExtraItemCount = () => Object.values(state.bagItems).reduce((total, quantity) => total + Math.max(0, quantity), 0);
  const getExtraSubtotal = () => Object.entries(state.bagItems).reduce((total, [key, quantity]) => total + bagCatalog[key].price * Math.max(0, quantity), 0);
  const getItemCount = () => state.curlerQty + (state.mascaraAdded ? 1 : 0) + (state.ritualAdded?.count || 0) + getExtraItemCount();
  const getSubtotal = () => state.curlerQty * 24 + (state.mascaraAdded ? 24 : 0) + (state.ritualAdded?.total || 0) + getExtraSubtotal();

  function updateBagCount() {
    const count = getItemCount();
    const bagControl = select(".site-header-actions button, .site-header-actions a[href='/cart']");
    if (!bagControl) return;
    bagControl.textContent = `BAG · ${count}`;
    bagControl.setAttribute("aria-label", `Open bag with ${count} items`);
  }

  function setCartOpen(open) {
    const overlay = select(".cart-overlay");
    const drawer = select(".cart-drawer");
    if (!overlay || !drawer) return;
    overlay.classList.toggle("is-open", open);
    drawer.classList.toggle("is-open", open);
    overlay.setAttribute("aria-hidden", String(!open));
    drawer.setAttribute("aria-hidden", String(!open));
    if (open) renderCart();
  }

  function renderCart() {
    const drawer = select(".cart-drawer");
    const head = select(".cart-head", drawer || document);
    if (!drawer || !head) return;

    [...drawer.children].forEach((child) => {
      if (child !== head) child.remove();
    });

    const itemCount = getItemCount();
    if (itemCount === 0) {
      head.insertAdjacentHTML("afterend", '<p class="cart-empty">Your bag is waiting.</p>');
      updateBagCount();
      return;
    }

    const subtotal = getSubtotal();
    const shippingRemaining = Math.max(0, 40 - subtotal);
    const progress = Math.min(100, (subtotal / 40) * 100);
    const extraItems = Object.entries(state.bagItems)
      .filter(([, quantity]) => quantity > 0)
      .map(([key, quantity]) => {
        const item = bagCatalog[key];
        return `<article class="cart-item compact">
          <div><img src="${asset(item.image)}" alt="${escapeHtml(item.name)}"></div>
          <section><p class="eyebrow">${escapeHtml(item.eyebrow)}</p><h3>${escapeHtml(item.name)}</h3><p>$${item.price}${quantity > 1 ? ` × ${quantity}` : ""}</p><button class="remove-item" data-cart-action="remove-extra" data-key="${key}">REMOVE</button></section>
        </article>`;
      }).join("");

    const cartMarkup = `
      <div class="shipping-progress ${shippingRemaining === 0 ? "complete" : ""}">
        <p>${shippingRemaining > 0 ? `You’re <strong>$${shippingRemaining}</strong> from complimentary U.S. shipping.` : "You’ve earned <strong>complimentary U.S. shipping.</strong>"}</p>
        <span><i style="width:${progress}%"></i></span>
      </div>
      ${state.curlerQty > 0 ? `<article class="cart-item"><div><img src="${asset("/products/pale-lavender/the-c-curl-no-bestseller.png")}" alt="The C Curl rose-copper eyelash curler"></div><section><p class="eyebrow">THE ORIGINAL</p><h3>The C Curl</h3><p>$24</p><div class="quantity"><button data-cart-action="decrease-curler" aria-label="Decrease The C Curl quantity">−</button><span>${state.curlerQty}</span><button data-cart-action="increase-curler" aria-label="Increase The C Curl quantity">+</button></div></section></article>` : ""}
      ${state.mascaraAdded ? `<article class="cart-item compact"><div><img src="${asset("/products/pale-lavender/lasting-curl-mascara.png")}" alt="Lasting Curl Mascara"></div><section><p class="eyebrow">DEFINE</p><h3>Lasting Curl Mascara</h3><p>$24</p><button class="remove-item" data-cart-action="remove-mascara">REMOVE</button></section></article>` : ""}
      ${state.ritualAdded ? `<article class="cart-item ritual-cart-item"><div><img src="${asset("/products/pale-lavender/c-curl-method-system-balanced.png")}" alt="Your custom C Curl ritual"></div><section><p class="eyebrow">YOUR C CURL METHOD</p><h3>My Lash Ritual</h3><p>${state.ritualAdded.names.map(escapeHtml).join(" · ")}</p><p>$${state.ritualAdded.total}</p><button class="remove-item" data-cart-action="remove-ritual">REMOVE RITUAL</button></section></article>` : ""}
      ${extraItems}
      ${!state.mascaraAdded ? `<div class="cart-recommendation"><p class="eyebrow">COMPLETE THE CURL</p><div><img src="${asset("/products/pale-lavender/lasting-curl-mascara.png")}" alt="Lasting Curl Mascara"><section><h3>Lasting Curl Mascara</h3><p>Lightweight definition designed to help hold the curl.</p><button data-cart-action="add-mascara">ADD MASCARA · $24</button></section></div></div>` : ""}
      <div class="cart-total"><span>SUBTOTAL</span><strong>$${subtotal}</strong></div>
      ${subtotal > 0 ? `<a class="button dark cart-checkout" href="/cart">CHECKOUT · $${subtotal}</a>` : '<button class="button dark cart-checkout" disabled>CHECKOUT · $0</button>'}
      <a href="#rituals" data-cart-action="close">OR EXPLORE THE RITUALS ${arrow}</a>`;

    head.insertAdjacentHTML("afterend", cartMarkup);
    updateBagCount();
  }

  function addBagItem(key) {
    state.bagItems[key] = (state.bagItems[key] || 0) + 1;
    updateBagCount();
    setCartOpen(true);
  }

  function setupCart() {
    const drawer = select(".cart-drawer");
    const overlay = select(".cart-overlay");
    const bagControl = select(".site-header-actions button, .site-header-actions a[href='/cart']");
    if (!drawer || !overlay) return;

    bagControl?.addEventListener("click", (event) => {
      event.preventDefault();
      setCartOpen(true);
    });
    overlay.addEventListener("click", () => setCartOpen(false));
    select(".cart-close", drawer)?.addEventListener("click", () => setCartOpen(false));

    drawer.addEventListener("click", (event) => {
      const control = event.target.closest("[data-cart-action]");
      if (!control) return;
      const action = control.dataset.cartAction;
      if (action === "decrease-curler") state.curlerQty = Math.max(0, state.curlerQty - 1);
      if (action === "increase-curler") state.curlerQty += 1;
      if (action === "remove-mascara") state.mascaraAdded = false;
      if (action === "add-mascara") state.mascaraAdded = true;
      if (action === "remove-ritual") state.ritualAdded = null;
      if (action === "remove-extra") {
        const key = control.dataset.key;
        state.bagItems[key] = Math.max(0, (state.bagItems[key] || 0) - 1);
      }
      if (action === "close") setCartOpen(false);
      else renderCart();
    });

    select(".method-product-comb .method-core-buy button")?.addEventListener("click", () => addBagItem("comb"));
    select(".method-product-featured .method-core-buy button")?.addEventListener("click", () => {
      state.curlerQty = Math.max(1, state.curlerQty);
      updateBagCount();
      setCartOpen(true);
    });
    select(".method-pad-card .method-product-buy button")?.addEventListener("click", () => addBagItem("pads"));

    const browButtons = selectAll(".method-brow-card .method-product-buy button");
    browButtons[0]?.addEventListener("click", () => {
      window.location.href = "/collections/ccurl?chooseShade=duo-shade-brett-brow-pencil";
    });
    browButtons[1]?.addEventListener("click", () => addBagItem("gel"));

    const productCards = selectAll(".method-product-card");
    select(".method-core-buy button", productCards[3])?.addEventListener("click", () => {
      window.location.href = "/collections/ccurl?waitlist=long-lash-growth-serum";
    });

    renderCart();
  }

  function getConsultationOverlay(modal) {
    if (!modal) return null;
    return selectAll(".consultation-modal-overlay")
      .find((overlay) => overlay.dataset.consultOverlay === modal.dataset.consultQuiz) || null;
  }

  function getConsultationState(modal, reset = false) {
    if (reset || !consultationStates.has(modal)) {
      consultationStates.set(modal, {
        answers: new Map(),
        notes: new Map(),
      });
    }
    return consultationStates.get(modal);
  }

  function setConsultOpen(open, modal = activeConsultation, trigger = null) {
    if (open && !modal) return;

    if (open && activeConsultation && activeConsultation !== modal) {
      const previousOverlay = getConsultationOverlay(activeConsultation);
      activeConsultation.classList.remove("is-open");
      activeConsultation.setAttribute("aria-hidden", "true");
      previousOverlay?.classList.remove("is-open");
      previousOverlay?.setAttribute("aria-hidden", "true");
    }

    const targetModal = modal || activeConsultation;
    if (!targetModal) return;
    const overlay = getConsultationOverlay(targetModal);

    targetModal.classList.toggle("is-open", open);
    targetModal.setAttribute("aria-hidden", String(!open));
    overlay?.classList.toggle("is-open", open);
    overlay?.setAttribute("aria-hidden", String(!open));

    if (open) {
      activeConsultation = targetModal;
      activeConsultationTrigger = trigger || document.activeElement;
      select("[data-consult-close]", targetModal)?.focus({ preventScroll: true });
      return;
    }

    if (activeConsultation === targetModal) {
      activeConsultation = null;
      const returnFocus = activeConsultationTrigger;
      activeConsultationTrigger = null;
      returnFocus?.focus?.({ preventScroll: true });
    }
  }

  function parseConsultationValues(value) {
    return new Set(
      String(value || "")
        .split(",")
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean),
    );
  }

  function getConsultationTokens(quizState) {
    const tokens = new Set();
    quizState.answers.forEach((value, field) => {
      const normalizedField = String(field).trim().toLowerCase();
      const normalizedValue = String(value).trim().toLowerCase();
      if (!normalizedValue) return;
      tokens.add(normalizedValue);
      if (normalizedField) tokens.add(`${normalizedField}:${normalizedValue}`);
    });
    return tokens;
  }

  function hasAnyConsultationValue(requiredValues, selectedValues) {
    return [...requiredValues].some((value) => selectedValues.has(value));
  }

  function hasAllConsultationValues(requiredValues, selectedValues) {
    return [...requiredValues].every((value) => selectedValues.has(value));
  }

  function updateConsultationResults(modal, quizState) {
    const selectedValues = getConsultationTokens(quizState);
    const resultNote = select("[data-consult-result-note]", modal);

    if (resultNote) {
      let note = resultNote.dataset.defaultNote || "";
      selectAll("[data-consult-question]", modal).forEach((question) => {
        const answerNote = quizState.notes.get(question.dataset.consultField);
        if (answerNote) note = answerNote;
      });
      resultNote.textContent = note;
    }

    selectAll("[data-consult-result]", modal).forEach((result) => {
      const bestValues = parseConsultationValues(result.dataset.bestMatchValues);
      const showWhenAll = parseConsultationValues(result.dataset.showWhenAll);
      const showWhenAny = parseConsultationValues(result.dataset.showWhenAny);
      const hideWhenAny = parseConsultationValues(result.dataset.hideWhenAny);
      const matchesAll = showWhenAll.size === 0 || hasAllConsultationValues(showWhenAll, selectedValues);
      const matchesAny = showWhenAny.size === 0 || hasAnyConsultationValue(showWhenAny, selectedValues);
      const isHidden = hideWhenAny.size > 0 && hasAnyConsultationValue(hideWhenAny, selectedValues);
      const isVisible = matchesAll && matchesAny && !isHidden;
      const isBest = isVisible && bestValues.size > 0 && hasAnyConsultationValue(bestValues, selectedValues);

      result.hidden = !isVisible;
      result.classList.toggle("is-best", isBest);

      const badge = select("[data-consult-best-badge]", result);
      if (badge) badge.hidden = !isBest;

      const action = select("[data-consult-result-action]", result);
      if (action) {
        action.textContent = isBest
          ? action.dataset.bestLabel || action.dataset.defaultLabel
          : action.dataset.defaultLabel;
      }
    });
  }

  function showConsultationStep(modal, stepIndex) {
    const questions = selectAll("[data-consult-question]", modal);
    const results = select("[data-consult-results]", modal);
    const totalSteps = questions.length;
    const safeStep = Math.max(0, Math.min(stepIndex, totalSteps));
    const showingResults = safeStep >= totalSteps;

    questions.forEach((question, index) => {
      question.hidden = showingResults || index !== safeStep;
    });
    if (results) results.hidden = !showingResults;

    const displayStep = Math.max(1, Math.min(safeStep + 1, totalSteps || 1));
    const displayTotal = totalSteps || 1;
    const stepLabel = select("[data-consult-step-label]", modal);
    const progressBar = select("[data-consult-progress-bar]", modal);
    const padStep = (value) => String(value).padStart(2, "0");

    if (stepLabel) stepLabel.textContent = `${padStep(displayStep)} / ${padStep(displayTotal)}`;
    if (progressBar) {
      const progress = totalSteps > 0 ? Math.min(100, ((safeStep + 1) / totalSteps) * 100) : 100;
      progressBar.style.width = `${progress}%`;
    }

    modal.dataset.consultStep = String(safeStep + 1);
    if (showingResults) updateConsultationResults(modal, getConsultationState(modal));
  }

  function clearConsultationFromStep(modal, quizState, stepIndex) {
    selectAll("[data-consult-question]", modal).forEach((question, index) => {
      if (index < stepIndex) return;
      quizState.answers.delete(question.dataset.consultField);
      quizState.notes.delete(question.dataset.consultField);
    });
  }

  function findConsultationModal(quizId) {
    const modals = selectAll(".lash-consultation[data-consult-quiz]");
    if (!quizId) return modals[0] || null;
    return modals.find((modal) => modal.dataset.consultQuiz === quizId) || null;
  }

  async function addConsultationProduct(button) {
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      if (!response.ok) throw new Error("Unable to add product");
      button.textContent = button.dataset.addedLabel || originalLabel;

      const modal = button.closest(".lash-consultation");
      if (modal) {
        const quizState = getConsultationState(modal);
        quizState.answers.clear();
        quizState.notes.clear();
        showConsultationStep(modal, 0);
        setConsultOpen(false, modal);
      }
    } catch {
      button.textContent = button.dataset.errorLabel || originalLabel;
    } finally {
      button.removeAttribute("aria-busy");
      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.textContent = originalLabel;
        button.disabled = false;
      }, 2000);
    }
  }

  function setupConsultation() {
    document.addEventListener("click", (event) => {
      if (!(event.target instanceof Element)) return;

      const opener = event.target.closest("[data-consult-open]");
      if (opener) {
        event.preventDefault();
        const modal = findConsultationModal(opener.dataset.consultOpen);
        if (!modal) return;

        const quizState = getConsultationState(modal, true);
        const presetField = opener.dataset.consultPresetField;
        const presetValue = opener.dataset.consultPresetValue;
        const presetNote = opener.dataset.consultResultNote;

        if (presetField && presetValue) {
          quizState.answers.set(presetField, presetValue);
          if (presetNote) quizState.notes.set(presetField, presetNote);
        }

        const requestedStep = Number(opener.dataset.consultStartStep || 1);
        showConsultationStep(modal, Math.max(0, requestedStep - 1));
        setConsultOpen(true, modal, opener);
        return;
      }

      const overlay = event.target.closest(".consultation-modal-overlay");
      if (overlay) {
        const modal = findConsultationModal(overlay.dataset.consultOverlay);
        setConsultOpen(false, modal);
        return;
      }

      const modal = event.target.closest(".lash-consultation");
      if (!modal) return;

      if (event.target.closest("[data-consult-close]")) {
        setConsultOpen(false, modal);
        return;
      }

      const answer = event.target.closest("[data-consult-answer]");
      if (answer) {
        const question = answer.closest("[data-consult-question]");
        if (!question) return;

        const quizState = getConsultationState(modal);
        const field = question.dataset.consultField;
        quizState.answers.set(field, answer.dataset.value);
        if (answer.dataset.resultNote) quizState.notes.set(field, answer.dataset.resultNote);
        else quizState.notes.delete(field);

        const questions = selectAll("[data-consult-question]", modal);
        showConsultationStep(modal, questions.indexOf(question) + 1);
        return;
      }

      const backButton = event.target.closest("[data-consult-back]");
      if (backButton) {
        const quizState = getConsultationState(modal);
        const targetStep = Math.max(0, Number(backButton.dataset.consultBack || 1) - 1);

        if (backButton.hasAttribute("data-consult-reset")) {
          quizState.answers.clear();
          quizState.notes.clear();
        } else {
          clearConsultationFromStep(modal, quizState, targetStep);
        }

        showConsultationStep(modal, targetStep);
        return;
      }

      const addButton = event.target.closest("[data-consult-add]");
      if (addButton) addConsultationProduct(addButton);
    });
  }

  function updateRitualBuilder() {
    const builder = select(".ritual-builder");
    if (!builder) return;
    const articles = selectAll(".ritual-builder-steps > article", builder);
    const prepButton = select("button", articles[0]);
    const liftButton = select("button", articles[1]);
    const defineButtons = selectAll("button", articles[2]);

    const updateToggle = (article, button, selected, label, price) => {
      article?.classList.toggle("is-selected", selected);
      if (!button) return;
      button.setAttribute("aria-pressed", String(selected));
      button.innerHTML = `<i>${selected ? "✓" : "+"}</i>${selected ? "IN MY RITUAL" : label}<b>$${price}</b>`;
    };

    updateToggle(articles[0], prepButton, state.ritualSelections.prep, "ADD TO RITUAL", 11);
    updateToggle(articles[1], liftButton, state.ritualSelections.lift, "ADD TO RITUAL", 24);
    articles[2]?.classList.toggle("is-selected", state.ritualSelections.lasting || state.ritualSelections.colossal);
    if (defineButtons[0]) {
      defineButtons[0].setAttribute("aria-pressed", String(state.ritualSelections.lasting));
      defineButtons[0].innerHTML = `<i>${state.ritualSelections.lasting ? "✓" : "+"}</i>LASTING CURL<b>$24</b>`;
    }
    if (defineButtons[1]) {
      defineButtons[1].setAttribute("aria-pressed", String(state.ritualSelections.colossal));
      defineButtons[1].innerHTML = `<i>${state.ritualSelections.colossal ? "✓" : "+"}</i>COLOSSAL CURL<b>$24</b>`;
    }

    const selected = getRitualSelection();
    const total = getRitualTotal();
    const remaining = Math.max(0, 40 - total);
    const footer = select(".ritual-builder-total", builder);
    const message = select("div > p", footer || document);
    const bar = select("div > span > i", footer || document);
    const addButton = select(":scope > button", footer || document);
    if (message) message.innerHTML = remaining > 0 ? `Add <strong>$${remaining}</strong> more for complimentary U.S. shipping.` : "<strong>Complimentary U.S. shipping</strong> is included.";
    if (bar) bar.style.width = `${Math.min(100, (total / 40) * 100)}%`;
    if (addButton) {
      addButton.disabled = selected.length === 0;
      addButton.textContent = `ADD MY RITUAL TO BAG · $${total}`;
    }
  }

  function setBuilderOpen(open) {
    const overlay = select(".ritual-builder-overlay");
    const builder = select(".ritual-builder");
    if (!overlay || !builder) return;
    overlay.classList.toggle("is-open", open);
    builder.classList.toggle("is-open", open);
    overlay.setAttribute("aria-hidden", String(!open));
    builder.setAttribute("aria-hidden", String(!open));
    if (open) updateRitualBuilder();
  }

  function setupRitualBuilder() {
    const builder = select(".ritual-builder");
    const overlay = select(".ritual-builder-overlay");
    if (!builder || !overlay) return;
    overlay.addEventListener("click", () => setBuilderOpen(false));
    select(".ritual-builder-head > button", builder)?.addEventListener("click", () => setBuilderOpen(false));
    selectAll("[data-open-ritual-builder]").forEach((button) => button.addEventListener("click", () => setBuilderOpen(true)));

    const articles = selectAll(".ritual-builder-steps > article", builder);
    select("button", articles[0])?.addEventListener("click", () => {
      state.ritualSelections.prep = !state.ritualSelections.prep;
      updateRitualBuilder();
    });
    select("button", articles[1])?.addEventListener("click", () => {
      state.ritualSelections.lift = !state.ritualSelections.lift;
      updateRitualBuilder();
    });
    const defineButtons = selectAll("button", articles[2]);
    defineButtons[0]?.addEventListener("click", () => {
      state.ritualSelections.lasting = !state.ritualSelections.lasting;
      updateRitualBuilder();
    });
    defineButtons[1]?.addEventListener("click", () => {
      state.ritualSelections.colossal = !state.ritualSelections.colossal;
      updateRitualBuilder();
    });
    select("button", articles[3])?.addEventListener("click", () => {
      window.location.href = "/collections/ccurl?waitlist=long-lash-growth-serum";
    });

    select(".ritual-builder-total > button", builder)?.addEventListener("click", () => {
      const selected = getRitualSelection();
      if (!selected.length) return;
      state.ritualAdded = { count: selected.length, total: getRitualTotal(), names: selected.map((item) => item.name) };
      setBuilderOpen(false);
      updateBagCount();
      setCartOpen(true);
    });
    updateRitualBuilder();
  }

  function setupNewsletter() {
    const form = select(".site-newsletter form");
    if (!form) return;
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const success = document.createElement("p");
      success.className = "site-newsletter-success";
      success.setAttribute("role", "status");
      success.textContent = "Thank you. You're on the list.";
      form.replaceWith(success);
    });
  }

  function setupStickyBuyBar() {
    const hero = select(".hero");
    const footer = select(".site-footer");
    const sticky = select(".pdp-mobile-buy.homepage-mobile-buy");
    if (!hero || !sticky || !("IntersectionObserver" in window)) return;

    let heroPassed = false;
    let footerVisible = false;
    const update = () => sticky.classList.toggle("is-visible", heroPassed && !footerVisible);
    const heroObserver = new IntersectionObserver(([entry]) => {
      heroPassed = !entry.isIntersecting;
      update();
    }, { threshold: 0.05 });
    const footerObserver = new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      update();
    }, { threshold: 0.02 });
    heroObserver.observe(hero);
    if (footer) footerObserver.observe(footer);
  }

  function setupBrandNameGuard() {
    const brandName = /C Curl/g;
    const cShape = /C[- ]shape(?:d)?/gi;
    const skippedTags = new Set(["SCRIPT", "STYLE", "TEXTAREA"]);

    const protectTextNode = (node) => {
      if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
      if (!node.nodeValue.includes("C Curl") && !/C[- ]shape/i.test(node.nodeValue)) return;
      if (node.parentElement && skippedTags.has(node.parentElement.tagName)) return;
      node.nodeValue = node.nodeValue
        .replace(brandName, "C\u00a0Curl")
        .replace(cShape, (match) => match.replace("-", "\u2011").replace(" ", "\u00a0"));
    };

    const protect = (root) => {
      protectTextNode(root);
      if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        protectTextNode(node);
        node = walker.nextNode();
      }
    };

    protect(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "characterData") protectTextNode(mutation.target);
        mutation.addedNodes.forEach(protect);
      });
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  function setupReviewSizing() {
    const sizingQuotes = [
      "I have super straight lashes that never hold a curl…until this. This curler actually lifts them and keeps them curled all day.",
      "The C Curl seems to be just what I need right now. I feel like it will curl my lashes without causing more stress or loss. Yay!",
      "I’m very happy with using the C Curl. I’m 64 with short lashes and the C Curl has really lifted my lashes to where I can see them!",
      "I wanted a lash serum that wouldn't thin the skin around my eyes or cause irritation. I’m thrilled with how much longer and fuller my lashes look.",
      "This actually works. I was so skeptical at first cause I have straight down asian lashes. But i threw away my old ones and only reaching out to this!",
      "It feels so light on my lashes and never clumps. It gives my shorter lashes beautiful length while still looking soft, separated, and completely natural.",
      "Recently, I’ve lost a spot of eyelashes on both eyes. The C Curl seems to be just what I need right now. It is curling my lashes without causing more stress or loss. YAY!",
      "Four weeks after my chemotherapy treatment ended, I lost almost all of my lashes. I started using this consistently twice a day for two months. My lashes grew back, and then some!",
    ];
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return;

    const resize = () => {
      let width = Math.min(1000, window.innerWidth - 100);
      let size = window.innerWidth <= 800 ? 16 : 26;
      const fits = (text) => {
        context.font = `${size}px Georgia`;
        let lines = 1;
        let line = "";
        text.split(/\s+/).forEach((word) => {
          const next = line ? `${line} ${word}` : word;
          if (context.measureText(next).width > width) {
            lines += 1;
            line = word;
          } else line = next;
        });
        return lines <= 2;
      };
      while (size > 6 && !sizingQuotes.every(fits)) size -= 0.25;
      document.documentElement.style.setProperty("--shared-review-font", `${size}px`);
    };

    resize();
    document.fonts?.ready.then(resize);
    window.addEventListener("resize", resize);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    setCartOpen(false);
    setBuilderOpen(false);
    setConsultOpen(false);
  });

  setupReviews();
  setupBeforeAfterCarousel();
  setupVideoRail();
})();
